import { render, staticRenderFns } from "./GrmBackBtn.vue?vue&type=template&id=01a37edc&"
import script from "./GrmBackBtn.vue?vue&type=script&lang=js&"
export * from "./GrmBackBtn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('01a37edc')) {
      api.createRecord('01a37edc', component.options)
    } else {
      api.reload('01a37edc', component.options)
    }
    module.hot.accept("./GrmBackBtn.vue?vue&type=template&id=01a37edc&", function () {
      api.rerender('01a37edc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Common/button/GrmBackBtn.vue"
export default component.exports